<template>
  <li class="flex">
    <div class="tit">{{ props.title }}</div>
    <div class="dateWrap flex">
      <div class="selectArea">
        <div class="selectBox">
          <button type="button" class="btnToggle" :class="{ show: isMonthOpenFlag, selected: monthData !== -1, error: isError }" @click.stop="onClickMonthToggle">
            {{ getSelectMonthString }}
          </button>
          <ul id="dropMenuMonth" class="dropMenu scrollY" :class="{ show: isMonthOpenFlag, up: isBottomUpOpen }">
            <li v-for="(month, index) in getLocalizedMonths" :key="index" class="dropItem" @click.stop="selectMonthData(index)">
              <button type="button" class="dropOption">{{ month }}</button>
            </li>
          </ul>
        </div>
      </div>
      <p>~</p>
      <div class="selectArea">
        <div class="selectBox">
          <button type="button" class="btnToggle" :class="{ show: isYearOpenFlag, selected: yearData !== -1, error: isError }" @click.stop="onClickYearToggle">
            {{ getSelectYearString }}
          </button>
          <ul id="dropMenuYear" class="dropMenu scrollY" :class="{ show: isYearOpenFlag, up: isBottomUpOpen }">
            <li v-for="(year, index) in getYears" :key="index" class="dropItem" @click.stop="selectYearData(year)">
              <button type="button" class="dropOption">{{ year }}</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
const { $i18n } = useNuxtApp();
const lang = computed(() =>
  $i18n.locale.value.toUpperCase()
);

const props = defineProps({
  title: { type: String, default: "" },
  defaultButtonStringMonth: { type: String, default: "" },
  defaultButtonStringYear: { type: String, default: ""},
  defaultDate: { type: String, default: null},
  isBottomUpOpen: { type: Boolean, default: false },
  isError: { type: Boolean, default: false },
  isMonthOpenFlag: { type: Boolean, default: false },
  isYearOpenFlag: { type: Boolean, default: false },
})
const emit = defineEmits(["onChangeDate","onChangeMenuFlag"])

const monthData = ref(-1);
const yearData = ref(-1);

onMounted(() => {
  if(props.defaultDate){
    monthData.value = new Date(props.defaultDate).getMonth();
    yearData.value = new Date(props.defaultDate).getFullYear();
  }
})

const getLocalizedMonths = computed(() => {
  const formatter = new Intl.DateTimeFormat(lang.value, { month: "long" });
  return Array.from({ length: 12 }, (_, i) => formatter.format(new Date(2024, i, 1)));
});

const getYears = computed(() => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 100;
  return Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i).reverse();
});

const getSelectMonthString = computed(() => {
  return monthData.value >= 0 ? getLocalizedMonths.value[monthData.value] : props.defaultButtonStringMonth;
})

const getSelectYearString = computed(() => {
  return yearData.value >= 0 ? yearData.value : props.defaultButtonStringYear;
})

const selectMonthData = (monthIndex: number) => {
  monthData.value = monthIndex;
  emit("onChangeMenuFlag", "month",false)
  onSelectPeriod();
}

const selectYearData = (year: number) => {
  yearData.value = year;
  emit("onChangeMenuFlag", "year",false)
  onSelectPeriod();
}

const onSelectPeriod = () => {
  if(monthData.value !== -1 && yearData.value !== -1){
    const date = new Date(yearData.value, monthData.value);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth()+ 1).padStart(2, '0')}-01`;
    emit("onChangeDate", formattedDate)
  }
}

const onClickMonthToggle = () => {
  emit("onChangeMenuFlag", "month",!props.isMonthOpenFlag)
}

const onClickYearToggle = () => {
  emit("onChangeMenuFlag", "year",!props.isYearOpenFlag)
}
</script>